import React from 'react';
import cn from 'classnames';
import Head from 'next/head';
import { homeUrl } from 'constants/index';
import Image from 'next/image';
import router from 'next/router';
import Footer from 'components/footer';
import style from './index.module.scss';
import UseScroll from 'utils/hooks/useScroll';
import OpenApp from 'components/openApp';
const navbar = [
  {
    key: 'home',
    title: '首页',
    url: '/campus2022',
  },
  {
    key: 'position',
    title: '职位',
    url: '/campus2022/position',
  },
];

interface Props {
  pageKey: string;
  children: React.ReactNode;
}
const Layout = (prop: Props) => {
  const { pageKey, children } = prop;
  const scrollTop = UseScroll();
  const goTo = (url: string) => {
    router.push(url);
  };
  return (
    <div>
      <Head>
        <link rel="icon" href="/v2/favicon.ico" />
        <title>小鱼易连2022秋季校园招聘-蛟龙计划</title>
      </Head>
      <header className={style.header}>
        <OpenApp />
        <div className={style.container}>
          <a href={homeUrl}>
            <Image src="/v2/images/login-logo.png" alt="logo" width="134" height="28" />
          </a>
        </div>
      </header>
      <div className={cn(style.place, 'for-mobile')}></div>
      <div className={style.banner}></div>
      <div className={style['nav-parent']}>
        <div className={cn(style.navbar, scrollTop > 458 && style.fixed)}>
          {navbar.map(item => {
            return (
              <div key={item.key} className={cn(style.navItem, pageKey === item.key && style.focus)} onClick={() => goTo(item.url)}>
                {item.title}
              </div>
            );
          })}
        </div>
      </div>
      <section>{children}</section>
      <Footer />
    </div>
  );
};

export default Layout;
